export function base64ToArrayBuffer(base64: any) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

 export  function arrayBufferToBase64(buffer: any) {
    if (typeof buffer === 'string') {
      buffer = base64ToArrayBuffer(buffer);
    }

    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64String = window.btoa(binary);
    return `data:image/jpeg;base64,${base64String}`;
  }


 export const groupByCategory = (calendars: any[]) => {
    return calendars.reduce((acc: { [key: string]: any[] }, current: any) => {
      const category = current.category || 'Uncategorized';

      if (!acc[category]) {
        acc[category] = [];
      }

      acc[category].push(current);
      return acc;
    }, {});
  };